import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
// Sections for this page
const useStyles = makeStyles(styles);

export default function ProductSection(props) {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} className={classes.description} style={{ color: '#333' }}>
          <div style={{ color: "#134c7a", margin: 0}}>
            <small>{props.data.description}</small>
            <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a'}}>नक्शा तथा विवरण</h3></span>
            <div style={{ width: '20px', borderBottom: "5px solid #134c7a", margin: 'auto' }}></div>
          </div>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} className={classes.description} style={{ color: '#333' }}>
          <div style={{ color: "#134c7a", margin: 0}}>
            {props.detail_info}
          </div>
        </GridItem>
        <GridItem xs={12} sm={8} md={8} className={classes.description} style={{ color: '#333', float: 'right' }}>
          <div style={{ color: "#134c7a", margin: 0}}>
            {props.map}
          </div>
          <div>
            {props.cultureAndHeritage}
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
